<template>
  <div class="box">
    <iframe
      class="iframe_box"
      :src="`/privacyService/${SRC}.html`"
      frameborder="0"
    >
    </iframe>
  </div>
</template>
<script>
export default { 
  name: 'PrivacyServicePage',
  data() {
    return {
      SRC: '',
    };
  },
  mounted() {
    console.log('PrivacyServicePage beforeCreate', window.location.search);
    const params = new URLSearchParams(window.location.search);
    const src = params.get('src') || '';
    this.SRC = src;
    console.log('PrivacyServicePage beforeCreate', this.SRC);
  },
  methods: {

  },
};
</script>

<style scoped>
.box {
  height:100vh;
}
.iframe_box {
  width: 100%;
  height: 100%;
}
</style>
